<template>
  <div class="EditAddModelEquipamento">
    <el-form v-loading="loadingPage" :model="ruleForm" ref="ruleForm" :rules="rules" @submit.prevent v-on:submit.prevent>
      <HeaderPage>
        <el-button style="height: 44px; margin-left: 1rem" native-type="submit" @click.prevent="submitForm('ruleForm')">Salvar</el-button>
        <el-dropdown v-if="ruleForm.id" trigger="click" @command="handleAction">
          <el-button type="text" icon="el-icon-more" class="el-dropdown-link"></el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-delete" command="DELETE">Excluir</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </HeaderPage>
      <el-card shadow="never">
        <el-form-item prop="name" label="Nome" :error="error.name">
          <el-input size="large" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :lg="8" :sm="8" :xs="24">
            <el-form-item prop="ref_external" label="Referencia externa" :error="error.ref_external">
              <el-input size="large" v-model="ruleForm.ref_external"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :sm="8" :xs="24">
            <el-form-item prop="provider_id" label="Provedor do modelo de equipamentos" :error="error.provider_id">
              <SearchProviders :disabled="isEdit" :model="ruleForm.provider_id" :isEdit="false" @handleValue=" (x) => { $set(ruleForm, 'provider_id', x) } " />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :sm="8" :xs="24">
            <el-form-item prop="acquirer_id" label="Adquirente" :error="error.acquirer_id">
              <SearchAcquirers :disabled="isEdit" :model="ruleForm.acquirer_id" :isEdit="false" @handleValue=" (x) => { $set(ruleForm, 'acquirer_id', x) } " />
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
    </el-form>
  </div>
</template>

<script>
import HeaderPage from "@/app/components/HeaderPage";
import {
  deleteEstaComercial, deleteModelEquipamento,
  getModelEquipamento,
  postModelEquipamento,
  putModelEquipamento
} from "@/app/domains/Records/services";
import {clearRuleForm, getErrorFilds, setFormData, makeErrorFilds} from "@/app/plugins/utils";
import SearchProviders from "@/app/components/Providers/SearchProviders";
import SearchAcquirers from "@/app/components/Acquirer/SearchAcquirers.vue";

export default {
  name: "EditAddModelEquipamento",
  components: {
    HeaderPage,
    SearchProviders,
    SearchAcquirers
},
  computed: {
    isEdit: function () {
      return !!(this.ruleForm.id)
    }
  },
  data () {
    return {
      loadingPage: false,
      ruleForm: {
        name: '',
        provider_id: '',
        ref_external: '',
        acquirer_id: '',
      },
      rules: {
        name: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        acquirer_id: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
        provider_id: [
          {required: true, message: 'Requerido', trigger: 'blur'}
        ],
      },
      error: {},
    }
  },
  methods: {
    async handleAction (act) {
      if (act === 'DELETE') {
        this.loadingPage = true
        this.$confirm('Deseja realmente deletar este Modelo de Equipamento?', 'Atenção', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          center: true,
          type: 'warning'
        }).then(async () => {
          try {
            await deleteModelEquipamento(this.ruleForm.id)
            await this.$router.push({name: 'records.modelEquipment.index'})
            this.$message({
              showClose: true,
              message: 'Excluido.',
              type: 'success'
            })
          } catch (e) {
            this.$message({
              showClose: true,
              message: e.data,
              type: 'error'
            })
          } finally {
            this.loadingPage = false
          }
        }).catch(() => {
          this.loadingPage = false
        });
      }
    },
    submitForm (ruleForm) {
      this.$refs[ruleForm].clearValidate()
      this.$refs[ruleForm].validate(async (valid) => {
        if (valid) {
          this.loadingPage = true
          try {
            if (this.ruleForm.id !== undefined) {
              await putModelEquipamento(this.ruleForm)
              await this.$router.push({name: 'records.modelEquipment.index'})
              this.$message({
                showClose: true,
                message: 'Atualizado com sucesso',
                type: 'success'
              })
            } else {
              await postModelEquipamento(setFormData(clearRuleForm(this.ruleForm)))
              this.$message({
                showClose: true,
                message: 'Adicionado com sucesso',
                type: 'success'
              })
              await this.$router.push({name: 'records.modelEquipment.index'})
            }
          } catch (e) {
            this.error = getErrorFilds(e);
            this.$message({
              showClose: true,
              message: makeErrorFilds(e)[Object.keys(makeErrorFilds(e))[0]],
              type: "error",
            });
          } finally {
            this.loadingPage = false
          }
        }
      })
    },
  },
  async mounted() {
    try {
      if (this.$route.params.id) {
        this.loadingPage = true
        let response = await getModelEquipamento(`/${this.$route.params.id}`)
        this.ruleForm = response.data
      }
    } catch (e) {
      
      this.$message({
        showClose: true,
        message: e.data.data,
        type: 'error'
      })
    } finally {
      this.loadingPage = false
    }
  }
}
</script>

<style scoped>

</style>
